import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from '../base.service';
import { MessageService } from '../message.service';
import { FormListModel } from './form-list-model';
import { LayoutListModel } from './layout-list-model';
import { MasterListModel } from './master-list-model';
import { NewFormModel } from './new-form-model';

@Injectable({
  providedIn: 'root'
})
export class FormsService extends BaseService {
 
  private wsBase: string =  "/form/";

  constructor(http: HttpClient, messageService:MessageService) {
    super(http, messageService);
  }

  loadFormsPage(page: number):Observable<FormListModel> 
  {
    var url = this.wsUrl(this.wsBase) + "forms?"+"page="+page;
    return this.dataGET(url);
  }

  loadMastersPage(page: number):Observable<MasterListModel> 
  {
    var url = this.wsUrl(this.wsBase) + "masters?"+"page="+page;
    return this.dataGET(url);
  }

  loadLayoutsPage(page: number):Observable<LayoutListModel> 
  {
    var url = this.wsUrl(this.wsBase) + "layouts?"+"page="+page;
    return this.dataGET(url);
  }

  loadNewFormModel():Observable<NewFormModel>{
    var url = this.wsUrl(this.wsBase) + "addformdata";
    return this.dataGET(url);
  }

   
  addNewForm(componentData: NewFormModel)
  {
    var url = this.wsUrl(this.wsBase)+"addform";
    return this.dataPOST(url, JSON.stringify(componentData));
  }
}
